// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleButton_jPcRY {

  background: #FFFFFF;
  border: none;
  border-radius : 0;
  display: inline-block;
}

.toggleButton_jPcRY > * {
  pointer-events: none;
}

.toggleButton_jPcRY:hover, .toggleButton_jPcRY:active, .toggleButton_jPcRY:focus { 
  outline:none;
}

.toggleButton_jPcRY:focus {
  border-color : rgba(75, 130, 252, 1.0);
}

.toggleButton_jPcRY:hover {
  background: #cccccc;
}

.toggleButton_jPcRY[data-value=true] {
  background: #5A5CE2;
  color : #FFFFFF;
}

.toggleButton-small_U9gOk {
  font-size: 11px;
  line-height:17px;
}



.toggleButton_jPcRY.toggleButton-link_U_sn3 {
  background: #959595;
  border : none;
  border-radius : 0;
}


.toggleButton_jPcRY.toggleButton-link_U_sn3:hover, .toggleButton_jPcRY.toggleButton-link_U_sn3:active, .toggleButton_jPcRY.toggleButton-link_U_sn3:focus { 
  outline:none;
}

.toggleButton_jPcRY:focus {
  border-color : rgba(75, 130, 252, 1.0);
}

.toggleButton_jPcRY.toggleButton-link_U_sn3:hover {
  background: #cccccc;
}

.toggleButton_jPcRY.toggleButton-link_U_sn3[data-value=true] {
  background: #5737BE;
  color : #FFFFFF;

}

.toggleButton_jPcRY.toggleButton-hollowDark_hPOpk {
  background:transparent;
  color:white;
  border-radius : 0;
}

.toggleButton_jPcRY.toggleButton-hollowDark_hPOpk[data-value=true] {
  background:#5737BE;
  border-radius : 0;
  border:none;
}

.toggleButton_jPcRY.toggleButton-hollowDark_hPOpk:hover {
  color: #845eff;
  border-radius : 0;
}

.toggleButton_jPcRY.toggleButton-hollowDark_hPOpk:hover[data-value=true] {
  color: white;
  border-radius : 0;
}

`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/ToggleButton.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".toggleButton {\n\n  background: #FFFFFF;\n  border: none;\n  border-radius : 0;\n  display: inline-block;\n}\n\n.toggleButton > * {\n  pointer-events: none;\n}\n\n.toggleButton:hover, .toggleButton:active, .toggleButton:focus { \n  outline:none;\n}\n\n.toggleButton:focus {\n  border-color : rgba(75, 130, 252, 1.0);\n}\n\n.toggleButton:hover {\n  background: #cccccc;\n}\n\n.toggleButton[data-value=true] {\n  background: #5A5CE2;\n  color : #FFFFFF;\n}\n\n.toggleButton-small {\n  font-size: 11px;\n  line-height:17px;\n}\n\n\n\n.toggleButton.toggleButton-link {\n  background: #959595;\n  border : none;\n  border-radius : 0;\n}\n\n\n.toggleButton.toggleButton-link:hover, .toggleButton.toggleButton-link:active, .toggleButton.toggleButton-link:focus { \n  outline:none;\n}\n\n.toggleButton:focus {\n  border-color : rgba(75, 130, 252, 1.0);\n}\n\n.toggleButton.toggleButton-link:hover {\n  background: #cccccc;\n}\n\n.toggleButton.toggleButton-link[data-value=true] {\n  background: #5737BE;\n  color : #FFFFFF;\n\n}\n\n.toggleButton.toggleButton-hollowDark {\n  background:transparent;\n  color:white;\n  border-radius : 0;\n}\n\n.toggleButton.toggleButton-hollowDark[data-value=true] {\n  background:#5737BE;\n  border-radius : 0;\n  border:none;\n}\n\n.toggleButton.toggleButton-hollowDark:hover {\n  color: #845eff;\n  border-radius : 0;\n}\n\n.toggleButton.toggleButton-hollowDark:hover[data-value=true] {\n  color: white;\n  border-radius : 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleButton": `toggleButton_jPcRY`,
	"toggleButton-small": `toggleButton-small_U9gOk`,
	"toggleButton-link": `toggleButton-link_U_sn3`,
	"toggleButton-hollowDark": `toggleButton-hollowDark_hPOpk`
};
export default ___CSS_LOADER_EXPORT___;
